// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import firebase from "firebase/compat/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0NtDXzXWr3pTyXKWUa_nH7NnpYF8Yr-0",
  authDomain: "my-notes-c8132.firebaseapp.com",
  projectId: "my-notes-c8132",
  storageBucket: "my-notes-c8132.appspot.com",
  messagingSenderId: "177526576311",
  appId: "1:177526576311:web:f80765769ebe290c726932",
  measurementId: "G-FPY96CF4HT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const db = getFirestore(app);
// const conlRef = collection(db, "notes");
// getDocs(conlRef).then((snapshot) => {
// console.log("***************************************\n", snapshot.docs);
// });

export { app, auth, db };
